import observe from '../state/store';
import render from './render';
import { setState } from "./state";
let _KOMPO_DEBUG_MODE_ON_ = false;
export default function app(root, state, router, debugModeOn) {
    if (!window)
        throw new Error('cannot initialize Kompo, window not available');
    if (debugModeOn) {
        _KOMPO_DEBUG_MODE_ON_ = true;
    }
    state = observe(state, root);
    /**
     * Adds construct function to Element prototype
     */
    Object.defineProperty(window.Element.prototype, 'construct', {
        writable: true,
        value: function () {
            throw new Error('Must override the construct method');
        }
    });
    /**
     * Adds kompo to
     */
    Object.defineProperty(window.Element.prototype, 'kompo', {
        writable: true,
        value: undefined
    });
    // Make available for all Elements
    Object.defineProperty(window.Element.prototype, '__kompo__', {
        value: {
            root,
            state,
            router
        }
    });
    return {
        start: function (selector) {
            if (selector) {
                setState(root, selector);
            }
            requestAnimationFrame(() => render(root));
            return root;
        }
    };
}
export function debugModeOn() {
    return _KOMPO_DEBUG_MODE_ON_;
}
//# sourceMappingURL=app.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/app.js
// module id = 2
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11